import { useEffect, useState } from "react";
import { Navbar } from "../components/Navbar";
import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
} from "../components/ui/card";
import {
  Table,
  TableHeader,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
} from "../components/ui/table";
import { useGetLogHistoryOfAdminQuery } from "../generated/graphql";
import {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from "../components/ui/pagination";
import { useToast } from "../components/ui/use-toast";
import { Toaster } from "../components/ui/toaster";
import { formatDate } from "../lib/formatDate";

export function Logs() {
  const { toast } = useToast();
  const [logsPage, setLogsPage] = useState(1);
  const [{ data: logsData, error: logsError }] = useGetLogHistoryOfAdminQuery({
    variables: { page: logsPage },
  });

  // logs
  const logs = logsData?.getLogHistoryOfAdmin;

  useEffect(() => {
    if (logsError) {
      toast({
        title: "Error",
        description: logsError.message,
        variant: "destructive",
      });
    }
  }, [logsError, toast]);

  return (
    <div className="flex min-h-screen w-full flex-col">
      <Navbar />
      <main className="flex flex-1 flex-col gap-4 p-4 md:gap-8 md:p-8">
        <Card className="xl:col-span-2">
          <CardHeader className="flex flex-row items-center">
            <div className="grid gap-2">
              <CardTitle>Logs</CardTitle>
            </div>
          </CardHeader>
          <CardContent>
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead
                    style={{
                      padding: "0.5rem",
                    }}
                  >
                    Date
                  </TableHead>
                  <TableHead>ID</TableHead>
                  <TableHead>User</TableHead>
                  <TableHead
                    style={{
                      padding: "0.5rem",
                    }}
                  >
                    Action
                  </TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {logs?.map((log, idx) => (
                  <TableRow key={idx}>
                    <TableCell
                      style={{
                        padding: "0.5rem",
                        fontSize: "13px",
                        lineHeight: "14px",
                      }}
                    >
                      {formatDate(log.date)}
                    </TableCell>
                    <TableCell>{log.id}</TableCell>
                    <TableCell>{log.username}</TableCell>

                    <TableCell
                      style={{
                        padding: "0.5rem",
                        fontSize: "13px",
                        lineHeight: "14px",
                      }}
                    >
                      {log.action}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <Pagination>
              <PaginationContent>
                <PaginationItem>
                  <PaginationPrevious
                    onClick={() => {
                      setLogsPage(logsPage - 1);
                    }}
                  />
                </PaginationItem>
                <PaginationItem>
                  <PaginationLink>{logsPage}</PaginationLink>
                </PaginationItem>
                <PaginationItem>
                  <PaginationNext
                    onClick={() => {
                      setLogsPage(logsPage + 1);
                    }}
                  />
                </PaginationItem>
              </PaginationContent>
            </Pagination>
          </CardContent>
        </Card>
      </main>
      <Toaster />
    </div>
  );
}
